import React from "react";
import aboutImage from "../../assets/images/Founder-image/founder.jpg";

const COLORS = {
  bgPrimary: "#fff",
  bgSecondary: "#0A0A0A",
  accent: "#A8485A",
  accentDeep: "#7A1F2B",
  textLight: "#F4EFE3",
};

const AboutSection = () => {
  const services = [
  {
    id: "01",
    title: "Criminal Law",
    desc: "Comprehensive legal representation in criminal cases, ensuring the protection of your rights and interests.",
  },
  {
    id: "02",
    title: "Cyber Crime",
    desc: "Expert legal assistance in cybercrime investigations, data breaches, online fraud, and digital security matters.",
  },
  {
    id: "03",
    title: "Service Matters",
    desc: "Professional legal support for employment disputes, promotions, disciplinary actions, and service-related matters.",
  },
];

  return (
    <section
      className="w-full py-4 sm:py-6 md:py-8 px-3 sm:px-6 md:px-10"
      style={{ backgroundColor: COLORS.bgPrimary }}
    >
      {/* MASTER SECTION CARD */}
      <div
        className="w-full max-w-7xl mx-auto overflow-hidden rounded-xl border border-white/10 shadow-2xl relative"
        style={{ backgroundColor: COLORS.bgSecondary }}
      >
        {/* Background Decorative Ampersand */}
        <div
          className="absolute top-0 right-0 p-4 sm:p-6 md:p-10 opacity-[0.05] select-none pointer-events-none overflow-hidden"
          style={{ color: COLORS.textLight }}
        >
          <h1 className="text-[20vw] sm:text-[18vw] lg:text-[15vw] font-black leading-none">
            &
          </h1>
        </div>

        {/* MAIN LAYOUT: Stack on mobile, side-by-side on lg+ */}
        <div className="flex flex-col lg:flex-row">

          {/* LEFT: IMAGE COLUMN */}
          <div className="w-full lg:w-5/12 relative overflow-hidden">
            <img
              src={aboutImage}
              alt="Founder"
              className="w-full object-contain object-center"
              style={{
                height: "clamp(260px, 50vw, 560px)",
                display: "block",
              }}
            />

            {/* Overlay gradient */}
            <div
              className="absolute inset-0"
              style={{
                background: `linear-gradient(to right, ${COLORS.bgSecondary}33, transparent)`,
              }}
            />

            {/* Experience Label */}
            <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6 md:p-8 backdrop-blur-sm bg-black/20 border-t border-white/10">
              <div className="flex items-center gap-3 sm:gap-4">
                <span
                  className="text-4xl sm:text-5xl font-bold"
                  style={{ color: COLORS.accent }}
                >
                  
                </span>
                <p className="text-[9px] sm:text-[10px] uppercase tracking-[0.25em] sm:tracking-[0.3em] leading-tight text-white font-semibold">
                  Years of Unmatched <br />
                  Legal Mastery
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT: CONTENT COLUMN */}
          <div className="w-full lg:w-7/12 flex flex-col justify-center relative">
            <div className="p-5 sm:p-8 md:p-12 lg:p-16 pb-0 sm:pb-0 md:pb-0 lg:pb-0">
              {/* Eyebrow */}
              <div className="flex items-center gap-3 mb-5 sm:mb-8">
                <div className="h-[1px] w-6 sm:w-8 bg-white/30" />
                <span
                  className="text-[9px] sm:text-[11px] font-bold uppercase tracking-[0.4em] sm:tracking-[0.5em]"
                  style={{ color: COLORS.accent }}
                >
                  Rai & Associates 
                </span>
              </div>

              {/* Heading */}
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-5 sm:mb-8 leading-tight">
                Crafting{" "}
                <span className="font-light opacity-70">Justice</span>
                <br />
                Through Expertise.
              </h2>

              {/* Body text */}
              <div className="space-y-5 sm:space-y-6 text-gray-300 max-w-xl">
                <p
                  className="text-sm sm:text-base md:text-lg leading-relaxed border-l-2 pl-4 sm:pl-6"
                  style={{ borderColor: COLORS.accent }}
                >
                  Based in New Delhi, we provide independent, elite legal
                  services with a focus on strategic integrity and client
                  protection.
                </p>

                {/* Stats Grid */}
                <div className="grid grid-cols-2 gap-6 sm:gap-10 py-5 sm:py-8 border-y border-white/5">
                  <div>
                    <p className="text-3xl sm:text-4xl font-bold text-white">
                      2,500+
                    </p>
                    <p className="text-[11px] sm:text-[13px] md:text-[15px] uppercase tracking-widest text-gray-400 font-bold mt-1">
                      Success Stories
                    </p>
                  </div>
                  <div>
                    <p className="text-3xl sm:text-4xl font-bold text-white">
                      98%
                    </p>
                    <p className="text-[11px] sm:text-[13px] md:text-[15px] uppercase tracking-widest text-gray-400 font-bold mt-1">
                      Client Retention
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* SERVICE CARDS — negative margin to bleed to card edges on md+ */}
            <div className="grid grid-cols-1 sm:grid-cols-3 border-t border-white/5 mt-6 sm:mt-10">
              {services.map((s, i) => (
                <div
                  key={s.id}
                  className="p-5 sm:p-6 md:p-8 hover:bg-white/[0.03] transition-colors border-b sm:border-b-0 border-white/5 last:border-b-0"
                  style={{
                    borderRight:
                      i < services.length - 1
                        ? "1px solid rgba(255,255,255,0.05)"
                        : "none",
                  }}
                >
                  <span
                    className="block font-extrabold mb-3"
                    style={{
                      color: COLORS.accent,
                      fontSize: "1.1rem",
                      textShadow: `0 0 8px ${COLORS.accentDeep}99`,
                    }}
                  >
                    [{s.id}]
                  </span>

                  <h4 className="text-white text-xs sm:text-sm font-bold uppercase tracking-wider mb-2">
                    {s.title}
                  </h4>

                  <p className="text-gray-400 text-xs sm:text-sm leading-relaxed">
                    {s.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;